.formFieldGroup {
    display: flex;
    margin: 0px;
}

.formFieldContainer {
    flex: 1;
    margin: 0px 10px 10px 10px;
}

.deleteButton {
    margin-right: auto;
}
